var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"side-menu-title"},[(_vm.to)?_c('router-link',{staticClass:"side-menu-title-link",attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('span',{staticClass:"side-menu-title-link"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }